import type { PassengerAuditViewModel } from './audit-detail-page.component';

/**
 * The hover label for one leg of a seat — "Subi · Kamdini → Bweyale · audited".
 *
 * Shared by the passenger bar at the top of the page and the leg rail in the booking panel:
 * they point at the same legs, so they must name them the same way. Kept in its own file
 * rather than on either component, because the rail's component imports the bar's and a
 * value import back the other way would close a runtime cycle.
 */
export function legTitle(leg: PassengerAuditViewModel): string {
  const name = leg.passenger.customerName || 'Passenger';
  const route = leg.originStop && leg.destinationStop ? ` · ${leg.originStop.name} → ${leg.destinationStop.name}` : '';
  return `${name}${route}${leg.passenger.audited ? ' · audited' : ''}`;
}
